import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IInjection } from 'src/app/storage/interfaces/injection.interface';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

const URL = environment.aws.amplify.API.REST;

@Injectable({ providedIn: 'root' })
export class InjectionsService {
  constructor(private translateService: TranslateService, private apiService: ApiService) { }

  async getMissionInjections(missionId: string): Promise<IInjection[] | null> {
    const translations = await this.translateService.get('MISSIONS').toPromise();
    const response = await this.apiService.get(
      `${URL}injections/mission/${missionId}`,
      translations['LABEL']
    );

    return response?.injections ?? null;
  }
}
